import { render, staticRenderFns } from "./TimeOffMain.vue?vue&type=template&id=49d1c196&scoped=true"
import script from "./TimeOffMain.vue?vue&type=script&lang=js"
export * from "./TimeOffMain.vue?vue&type=script&lang=js"
import style0 from "./TimeOffMain.vue?vue&type=style&index=0&id=49d1c196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d1c196",
  null
  
)

export default component.exports